import React from 'react';
import {FC} from 'react';
import Can from 'features/hylian-shield/can';
import {tableSlice} from 'features/table/slice';
import {MODAL} from 'features/modal-notch/constants';
import {Trash2, Edit} from 'react-feather';
import {Trans, useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import showModal from 'store/ui/actions/show-modal';
import {uiActions} from 'store/ui/ui-slice';
import {ProductFamily} from 'types/product-family';
import Button from 'components/button';

interface Props {
  family: ProductFamily;
}

const FamilyActions: FC<Props> = ({family}) => {
  const navigate = useNavigate();

  const {id} = family;

  const dispatch = useDispatch();

  const {t} = useTranslation();

  const destroyFamily = () => {
    dispatch(
      tableSlice.actions.destroyResource({
        resourceId: id,
        resourceName: 'families',
      })
    );
  };

  return (
    <div className="d-flex  ">
      <Can action="administration" subject="products">
        <Button
          className="me-2"
          color="transparent"
          onClick={() => {
            dispatch(
              showModal(MODAL.FAMILY_UPDATE_FORM, {
                family,
              })
            );
          }}
        >
          <Edit size={20} />
        </Button>

        <Button
          tag="button"
          color="transparent"
          onClick={e =>
            dispatch(
              uiActions.confirmDelete({
                resourceId: id,
                name: 'families',
                onDestroy: destroyFamily,
              })
            )
          }
        >
          <Trash2 size={20} className="text-danger" />
        </Button>
      </Can>
    </div>
  );
};

export default FamilyActions;
